import { Button, Link, Typography } from '@mui/material';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { BaseDialog } from '@/components/shared/base-dialog';
import { Icon } from '@/components/shared/icon';
import { ExternalUrls } from '@/constants';

interface CourseLimitExceededDialogProps {
  onClose: () => void;
}

export const CourseLimitExceededDialog = ({
  onClose,
}: CourseLimitExceededDialogProps) => (
  <BaseDialog
    onClose={onClose}
    open={true}
    actionsComponent={
      <Button onClick={onClose} variant="contained">
        Entendi
      </Button>
    }
    icon={<Icon name="sign-post" />}
  >
    <Typography fontWeight={fontWeights.fontWeightSemibold} mb={1}>
      Acreditamos que há um limite de cursos a serem realizados simultaneamente
      com qualidade para garantir o melhor aproveitamento da sua experiência.
    </Typography>
    <Typography>
      Você atingiu este limite. Se já concluiu algum dos seus cursos e deseja
      iniciar uma nova matrícula, entre em contato com nosso{' '}
      <Link href={ExternalUrls.Support} target="_blank" color="primary.dark">
        atendimento
      </Link>
      .
    </Typography>
  </BaseDialog>
);
